import React from 'react';
import type { ToastKind } from './Toast';
import { IntegrationsPanel } from '../features/integrations/IntegrationsPanel';
import { useLanguage } from '../lib/i18n';

interface IntegrationsViewProps {
  onNotify: (kind: ToastKind, text: string) => void;
}

/**
 * Ana ekrandaki "Entegrasyonlar" sayfası — yalnızca başlık ve sayfa kabı.
 * İçerik Ayarlar > Entegrasyonlar ile aynı panelden geliyor, iki ekran
 * birbirinden ayrışmasın.
 */
export const IntegrationsView: React.FC<IntegrationsViewProps> = ({ onNotify }) => {
  const { t } = useLanguage();

  return (
    <div className="mx-auto w-full max-w-5xl select-none px-6 py-8">
      <div className="space-y-1">
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{t('Entegrasyonlar', 'Integrations')}</h1>
        <p className="text-sm text-muted-foreground">
          {t(
            'Takvimlerini bağla, botun toplantılara katılsın, özetler istediğin yere gitsin.',
            'Connect your calendars, let the bot join your meetings and send summaries where you want them.'
          )}
        </p>
      </div>

      <div className="mt-6">
        <IntegrationsPanel onNotify={onNotify} />
      </div>
    </div>
  );
};
